import { FlatList, TouchableOpacity, View, Text } from "react-native";
import React, { memo } from "react";
import Animated from "react-native-reanimated";

import ExperienceCard from "./ExperienceCard";

const ExperienceList = ({
  data,
  receiverUserInfo,
  scrollfunction,
  horizontal,
  contentContainerStyle,
  ...other
}: {
  data: any;
  receiverUserInfo?: any;
  scrollfunction?: any;
  horizontal?: boolean;
  contentContainerStyle?: any;
}) => {
  // const { data, receiverUserInfo, scrollfunction, ...other } = props;
  // console.log(scrollfunction)

  const renderExperienceCard = ({ item }: { item: any }) => (
    <ExperienceCard scrollfunction={scrollfunction} {...item} />
  );

  return (
    <>
      <Animated.FlatList
        data={data}
        keyExtractor={(item) => item._id}
        renderItem={renderExperienceCard}
        showsHorizontalScrollIndicator={false}
        horizontal={horizontal}
        contentContainerStyle={contentContainerStyle}
        {...other}
      />
    </>
  );
};

export default memo(ExperienceList);
